import { Streams } from "@graylog/server-api";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import PaginationURL from "util/PaginationURL";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
export const fetchStreams = () => fetch("GET", qualifyUrl("/streams")).then((result) => result.streams).catch((errorThrown) => {
  UserNotification.error(`Loading streams failed with status: ${errorThrown}`, "Could not load streams");
  throw errorThrown;
});
export const searchStreamsPaginated = (page, perPage, query, additional) => {
  const url = PaginationURL(ApiRoutes.StreamsApiController.paginated().url, page, perPage, query, additional);
  return fetch("GET", qualifyUrl(url)).then((response) => {
    const {
      elements,
      query: responseQuery,
      attributes,
      pagination: { count, total, page: responsePage, per_page: responsePerPage }
    } = response;
    return {
      list: elements,
      attributes,
      pagination: {
        count,
        total,
        page: responsePage,
        perPage: responsePerPage,
        query: responseQuery
      }
    };
  });
};
export const updateStream = (streamId, data) => fetch("PUT", qualifyUrl(ApiRoutes.StreamsApiController.update(streamId).url), data).catch((errorThrown) => {
  UserNotification.error(`Updating Stream failed with status: ${errorThrown}`, "Could not update Stream");
  throw errorThrown;
});
export const removeStream = (streamId) => Streams.remove(streamId).then(() => CurrentUserStore.reload());
export const pauseStream = (streamId) => Streams.pause(streamId).catch((errorThrown) => {
  UserNotification.error(`Pausing Stream failed with status: ${errorThrown}`, "Could not pause Stream");
  throw errorThrown;
});
export const resumeStream = (streamId) => Streams.resume(streamId).catch((errorThrown) => {
  UserNotification.error(`Resuming Stream failed with status: ${errorThrown}`, "Could not resume Stream");
  throw errorThrown;
});
export const cloneStream = (streamId, data) => fetch("POST", qualifyUrl(ApiRoutes.StreamsApiController.cloneStream(streamId).url), data).catch((errorThrown) => {
  UserNotification.error(`Cloning Stream failed with status: ${errorThrown}`, "Could not clone Stream");
  throw errorThrown;
}).then(() => CurrentUserStore.reload());
export const testMatch = (streamId, message) => fetch("POST", qualifyUrl(ApiRoutes.StreamsApiController.testMatch(streamId).url), message).catch(
  (error) => {
    UserNotification.error(
      `Testing stream rules of stream failed with status: ${error.message}`,
      "Could not test stream rules of stream"
    );
    throw error;
  }
);
